module.exports = __webpack_public_path__ + "static/media/dashboard-menu.95417094.svg";